const AT = require("../core/vault/ActionTypes");
const UpdateParent = require("./vault/UpdateParent");

const initialize = function(vault, updater) {
	UpdateParent.augment(updater);
	vault.dispatchNow({type: AT.PARENT_INITIAL});
	vault.dispatchNow({type: AT.REPORT_INITIAL});
};

module.exports = {
	initialize,

	PageAccount: require("./account/PageAccount"),
	PageSubscribe: require("./account/PageSubscribe"),
	PageParent: require("./report/PageParent"),
	PageParentStudent: require("./report/PageParentStudent"),
	PageParentSupport: require("./report/PageParentSupport"),
	PageGiftBucksConfirmation: require("./report/PageGiftBucksConfirmation"),
	PagePrimaryRegistration: require("./primaryRegistration/PagePrimaryRegistration"),

	OpsParentAcc: require("./vault/OpsParentAcc"),
	OpsParentSubChange: require("./vault/OpsParentSubChange"),
};
